<template>
    <div class="calendar-cell-content" v-if="! calendarDateModel.isEmptyDateCell">
        <div class="calendar-date-date" v-html="getNumericTranslation(calendarDateModel.getDisplayDate())"></div>
        <i v-if="calendarDateModel.isLoading()" class="fa-solid fa-spinner fa-spin"></i>
        <div v-else-if="calendarDateModel.isAvailable() && calendarDateModel.hasPrice()" class="calendar-date-price">
            <p v-if="calendarDateModel.hasDiscount()" class="calendar-date-price-strike">
                <small v-html="calendarDateModel.getDiscountedPrice()"></small>
            </p>
            <p v-html="calendarDateModel.getPrice()"></p>
        </div>
        <div class="calendar-date-messages"
             v-if="calendarDateModel.hasMessageToDisplay()"
             v-html="calendarDateModel.calendarConfigModel.getMessagesToDisplay(calendarDateModel)">
        </div>
    </div>
</template>
<script>
/**
 * This component defines the default html to display for a given date cell.
 */
import CalendarDateModel from "../Models/CalendarDateModel.js";
import {getNumericTranslation} from '../helpers.js';
export default {
    name: "CalendarDate",
    props: {
        calendarDateModel: {
            required: true,
            type: CalendarDateModel
        }
    },
    /**
     * @param calendarDateModel {CalendarDateModel}
     */
    setup({ calendarDateModel }) {
        return {
            calendarDateModel,
            getNumericTranslation
        }
    }
}
</script>
